import React from 'react'
import { useTranslation } from 'react-i18next'
import tabletscreen from "./tablet-screen.svg"
import mobileonly from "./mobileonly.svg"
import appstore from "./appstore.svg"
import googleplay from "./googleplay.svg"

export default function Responsive() {
    const { t } = useTranslation("common")

    return (
        <div>
            <div className="tablet-screen-msg">
                <div className="rotate-msg">
                    <div>
                        <h2>{t("react_rotate_device")}</h2>
                        <p>{t("react_landscape_mode")}</p>
                    </div>
                    <img src={tabletscreen} alt="" className="img-fluid" />
                </div>
            </div>

            <div className="mobile-screen-msg">
                <img src={mobileonly} alt="" className="img-fluid" />
                <div className="app-msg pb-2">
                    <h2>{t("react_attention")}</h2>
                    <p>{t("react_download_app")}</p>
                </div>
                <div className="playstore">
                    <a
                        href="https://apps.apple.com/ie/app/ronspot-desk-parking-mgt/id1290760801"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={appstore} alt="" className="img-fluid" />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=ie.jemstone.ronspot&hl=en"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <img src={googleplay} alt="" className="img-fluid" />
                    </a>
                </div>
            </div>
        </div>
    )
}
